export default {
  required: [
    v => (v !== null && String(v).length > 0) || 'Campo obligatorio',
  ],
  numeric: [
    v => !isNaN(v) || 'El valor debe ser numérico',
    v => v > 0 || 'El valor debe ser mayor a 0',
  ],
};



// WEBPACK FOOTER //
// ./src/utils/validation.js